// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"beaf3179","74":"34681997","124":"5a16f3d2","365":"e3a94636","378":"43320d51","488":"c3a7d076","658":"948503b1","957":"1aa308f5"}[chunkId] + ".chunk.js";
};